export default __webpack_public_path__ + "static/media/330_dummy2016-baeckerei01-de.be4ff37b.png";